import { createAuthClient } from "better-auth/react";

const fallbackBaseURL =
  typeof window !== "undefined" ? window.location.origin : "http://localhost:1355";

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_AUTH_URL || fallbackBaseURL,
});
